import { Flex, SkeletonBox, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import { useInvoiceMultiCurrencyAccess } from '@features/invoices/hooks/useInvoiceMultiCurrencyAccess'

// Heights of the groups in PresetsSettingsFormFields, each at full width.
// A document-defaults row is 20px label + 4px gap + 50px control.
// With currency, item type is a second row. Without it, language and item type share one row.
// Contact person: 24px heading + 16px gap + two 74px field rows + 16px gap between the rows.
const contactPersonSkeleton = { height: 204, id: 'contact-person' }
const documentDefaultsRowSkeleton = { height: 74, id: 'document-defaults-row' }

export const PresetsSettingsFormFieldsSkeletons = (): ReactElement => {
  const { shouldDisplayInvoiceMultiCurrency } = useInvoiceMultiCurrencyAccess()

  const documentDefaultsSkeletons = shouldDisplayInvoiceMultiCurrency
    ? [documentDefaultsRowSkeleton, { ...documentDefaultsRowSkeleton, id: 'item-type' }]
    : [documentDefaultsRowSkeleton]

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      {[...documentDefaultsSkeletons, contactPersonSkeleton].map(({ height, id }) => (
        <SkeletonBox fullWidth height={height} key={id} />
      ))}
    </Flex>
  )
}
